export const TAX_RATE = 11;
